import * as React from "react";
import * as QueryString from "query-string";
import axios from "axios";
import { connect } from "react-redux";
import { FormattedHTMLMessage } from "react-intl";

import { logException } from "@vingle/wtf-sdk/helpers/errorLogger";
import PulseLoadingDot from "app/common/components/pulseLoadingDot";
import { IAppState } from "app/rootReducer";
import {
  confirmUser,
  USER_CONFIRM_TYPE,
} from "@vingle/wtf-sdk/actions/userConfirmation";
import { isBrowser } from "@vingle/wtf-sdk/helpers/envChecker";
import { VingleURL } from "@vingle/wtf-sdk/url";
import { match } from "react-router";
import { IAppStore } from "app/store";

function mapStateToProps(state: IAppState) {
  return {
    confirmState: state.userConfirmation.confirmState,
  };
}

interface IProps extends ReturnType<typeof mapStateToProps> {}

class UserConfirmation extends React.PureComponent<IProps> {
  public componentDidMount() {
    if (isBrowser()) {
      setTimeout(() => {
        window.location.href = new VingleURL.Home().toString();
      }, 1000);
    }
  }

  public render() {
    return (
      <div
        style={{
          height: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            display: "flex",
            width: "100%",
            top: "40vh",
          }}
        >
          <div style={{ flex: 1, textAlign: "center", whiteSpace: "pre-line" }}>
            {this.renderMessage()}
          </div>
        </div>
        <PulseLoadingDot />
      </div>
    );
  }

  public componentDidCatch(error: Error, context: any) {
    logException({ error, context });
  }

  private readonly renderMessage = () => {
    const messageId =
      this.props.confirmState === USER_CONFIRM_TYPE.CONFIRMED
        ? "user_confirmation.new_user_confirmed"
        : this.props.confirmState === USER_CONFIRM_TYPE.ALREADY_CONFIRMED
        ? "user_confirmation.already_confirmed"
        : "user_confirmation.error";

    return <FormattedHTMLMessage id={messageId} />;
  };
}

export default connect(mapStateToProps)(UserConfirmation);

export async function getInitialData({
  requestUrl,
  appStore,
}: {
  match: match<Vingle.IMatchParams>;
  appStore: IAppStore;
  requestUrl: string;
}) {
  const splitUrl = requestUrl.split("?");

  if (splitUrl.length > 1) {
    const queryString = QueryString.parse(`?${splitUrl[1]}`);
    if (queryString && queryString.confirmation_token) {
      await appStore.dispatch(
        confirmUser(
          queryString.confirmation_token as string,
          axios.CancelToken.source().token,
        ),
      );
    }
  }
}
